document.addEventListener("DOMContentLoaded", () => {
  var productsList = $("#products")
  var navItem = $("#products>a")
  var navLabel = $("#SiteNavLabel-products")

  productsList.hover(
    function () {
      navItem.addClass("hover");
      navLabel.slideDown();
    },
    function () {
      navLabel.css("display", "none");
      navItem.removeClass("hover");
    }
  );

  var navLink = $(".has-childLink")

  navLink.hover(
    function () {
      $(this).addClass('site-nav--active-dropdown')
    },
    function () {
      $(this).removeClass('site-nav--active-dropdown')
    }
  );
  
});